import { store, storeActions } from '~/utility/BinSentry-ui-utility';
import '../common/bn-icon';
import './parts/work-order-view';
import { LitEntity, html, css } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';

class WorkOrdersShowView extends LitEntity {
  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
      }
      .header {
        margin: 0 .5rem .5rem;
      }
      h1 {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
    `];
  }

  renderEntity() {
    const locationHref = this.getHref('https://api.binsentry.com/rel/work-order-location');

    return html`
      <div class="header">
        <h1>
          <a href="/work-order-schedule/work-orders?locationId=${encodeURIComponent(locationHref)}">
            <button class="button button--outlined">
              <bn-icon name="far fa-less-than"></bn-icon>
            </button>
          </a>
          Work Order #${this.getProperty('referenceId')}
        </h1>
      </div>

      <work-order-view .href="${this.href}" @complete="${this._onCompleteWorkOrder}"></work-order-view>
    `;
  }

  _onCompleteWorkOrder() {
    const locationId = this.getHref('https://api.binsentry.com/rel/work-order-location');
    store.dispatch(storeActions.navigate('/work-order-schedule/work-orders', { locationId }));
  }
}

window.customElements.define('work-order-show-view', WorkOrdersShowView);
